import React from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';
import { FCWithFragments } from '@modernloop/shared/components';

import { GoogleHealthCheckBanner_GoogleFragment } from 'src/generated/mloop-graphql';

import AppWideBanner, { AppWideBannerAction } from '../AppWideBanner';

interface Fragments {
  google: GoogleHealthCheckBanner_GoogleFragment;
}

interface Props {
  retry: AppWideBannerAction;
}

const GoogleHealthCheckBanner: FCWithFragments<Fragments, Props> = ({ google, retry }) => {
  const { t } = useTranslation();
  // hide if its not installed or is healthy
  if (!google || !google?.isInstalled || google?.isHealthy) {
    return null;
  }

  const endpoints = [
    !google.canReadDirectory && t('hiring-dashboard-nav:nav.banner.endpoint.employeeDirectory'),
    !google.canReadCalendars && t('hiring-dashboard-nav:nav.banner.endpoint.calendars'),
    !google.canReadMeetingRooms && t('hiring-dashboard-nav:nav.banner.endpoint.meetingRooms'),
  ].filter(Boolean) as string[];

  const text =
    endpoints.length > 0
      ? t('hiring-dashboard-nav:nav.banner.integrationUnhealthyWithEndpoints', {
          integrationName: 'Google Workspace',
          endpoints,
        })
      : t('hiring-dashboard-nav:nav.banner.integrationUnhealthy', { integrationName: 'Google Workspace' });

  return <AppWideBanner color="foreground" backgroundColor="error" text={text} action={retry} />;
};

GoogleHealthCheckBanner.fragments = {
  google: gql`
    fragment GoogleHealthCheckBanner_google on GoogleIntegrationHealth {
      isHealthy
      isInstalled
      canReadDirectory
      canReadCalendars
      canReadMeetingRooms
    }
  `,
};

export default GoogleHealthCheckBanner;
